export const APP_NAME = 'Bumpy';